import Repository from '@/repositories/RepositoryFactory';
import groupRepository from "../../repositories/groups";
import ApiState from "../../enums/APISTATE";

const groups = Repository.get('groups');
/**
 * Removes values from
 * @param { Array } array - This array
 * @param { Function } where - This is true
 * @returns { Array } - And return a new array
 */
 export function arrayRemoveWhere(array, where) {
  return array.filter(val => !where(val));
}

export function sleep(ms) {
  return new Promise(res => setTimeout(res, ms));
}

export default ({
  namespaced: true,
  state: {
    apiState: ApiState.INIT,
    groupState: ApiState.INIT,
    groups: [],
    group: {},
    groupsForUser: [],
    groupsForUserApiState: ApiState.INIT,
    usersForGroup: [],
    usersForGroupApiState: ApiState.INIT
  },
  mutations: {
    setApiState: (state, apiState) => {
      state.apiState = apiState;
    },
    setGroup(state, response) {
      const { data } = response;
      state.group = data;
      state.apiState = ApiState.LOADED;
    },
    setGroups(state, response) {
      const { data } = response;
      state.groups = data;
      state.apiState = ApiState.LOADED;
    },
    removeGroup(state, id) {
      state.groups = arrayRemoveWhere(state.groups, group => group.id === id);

      if (state.group) {        
        state.group.isRemoved = true;
      }
    },
    setState(state, apiState) {
      state.groupState = apiState;
    },
    initialized(state, { groups }) {
      state.groups = groups;
    },
    setGroupsForUserApiState(state, apiState) {
      state.groupsForUserApiState = apiState;
    },
    setGroupsForUser(state, response) {
      const { data } = response;
      state.groupsForUser = data;
      state.groupsForUserApiState = ApiState.LOADED;
    },
    setUsersForGroupApiState(state, apiState) {
      state.usersForGroupApiState = apiState;
    },
    setUsersForGroup(state, response) {
      const { data } = response;
      state.usersForGroup = data;
      state.usersForGroupApiState = ApiState.LOADED;
    }
  },
  actions: {
    getAllGroups({commit}) {
      commit('setApiState', ApiState.LOADING);
      return new Promise((resolve, reject) => {
        groups.getAllForMyCalendar().then((response) => {
          commit('setGroups', response);
          resolve();
        }).catch((error) => {
          console.error(error);
          commit('setApiState', ApiState.ERROR);
          reject();
        });
      });
    },
    async initialize({ commit }) {
      commit("setState", ApiState.LOADING);
      try {
        const groups = await groupRepository.getAll();
        commit("initialized", groups);
        commit("setState", ApiState.LOADED);
      } catch {
        commit("setState", ApiState.ERROR);
      }
    },
    async getGroupById({ commit }, id) {
      try {
        const group = await groupRepository.getById(id);
        commit("setGroup", group)
        return group;
      } catch {
        // Something error handly
      }
    },
    async removeGroup({ commit }, id) {
      try {
        await groupRepository.remove(id);
        commit("removeGroup", id);
        return true;
      } catch {
        return false;
      }
    },
    async getGroupsForUser({ commit }, id) {
      commit('setGroupsForUserApiState', ApiState.LOADING);
      try {
        commit('setGroupsForUser', await groupRepository.getGroupsForUser(id));
      }
      catch (error) {
        console.error(error);
        commit('setGroupsForUserApiState', ApiState.ERROR);
      }
    },
    async getUsersGorGroup({ commit }, id) {
      commit('setUsersForGroupApiState', ApiState.LOADING);
      try {
        commit('setUsersForGroup', await groupRepository.getUsersGorGroup(id));
      }
      catch (error) {
        console.error(error);
        commit('setUsersForGroupApiState', ApiState.ERROR);
      }
    },
    async updateGroup({ commit, dispatch, state }, dto) {
      commit('setState', ApiState.LOADING);
      try {
        const group = await groupRepository.update(dto);
        commit("setGroup", group)
      }
      catch (error) {
        console.error(error);
        commit('setState', ApiState.ERROR);
      }
    },
    async createGroup({ commit, dispatch, state }, dto) {
      commit('setState', ApiState.LOADING);
      try {
        const group = await groupRepository.create(dto);
        commit("setGroup", group)
      }
      catch (error) {
        console.error(error);
        commit('setState', ApiState.ERROR);
      }
    },
  },
  getters: {
    group(state) { 
      return state.group; 
    },
    groupState(state) {
      return state.groupState;
    },
    groupsIsLoading(state) { 
      return state.groupState === ApiState.LOADING 
    },
    groupApiState(state) {
      return state.apiState;
    },
    groups(state) { 
      return state.groups; 
    },
    getGroupById: (state) => (groupId) => state.groups.find(q => q.id === groupId),
    groupsForUserApiState(state) {
      return state.groupsForUserApiState;
    },
    groupsForUser(state) {
      return state.groupsForUser;
    },
    usersForGroupApiState(state) {
      return state.usersForGroupApiState;
    },
    usersForGroup(state) {
      return state.usersForGroup;
    }
  }
});
